<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <stock-transaction-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import StockTransactionCrud from "./StockTransactionCrud";
    export default {
        name: "StockTransaction",
        components: {StockTransactionCrud}
    }
</script>

<style scoped>

</style>

